/*
 * @Descripttion: 直播与回看
 * @Author: gouyang
 * @Date: 2021-01-18 14:06:02
 * @LastEditors: gouyang
 * @LastEditTime: 2021-03-10 09:00:51
 */
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import Footer from '../../components/Footer';
import { apiGetLive, liveAction, playBackAction } from '../../redux/action/live.action';
import { mergeProps, getSearchParams } from '../../util';
import LivePlayBack from './components/LivePlayBack';
import EasteduLiveWeb from './components/EasteduLiveWeb';
import { PlaybackInfo, LiveBroadcastInfo, LiveUserInfo } from './interface';
import './index.less';

interface IProp extends RouteComponentProps {
  lesson: any;
  live: LiveBroadcastInfo;
  reviews: PlaybackInfo;
}

interface IState {
  url: string;
  selectedIndex: number;
  playBack: boolean;
  playBackLists: any[];
  playbackInfo: PlaybackInfo;
  liveBroadcastInfo: LiveBroadcastInfo;
  liveType: 'live-broadcase' | 'playback' | null;
  liveTeacherInfo: any;
  liveUserInfo: LiveUserInfo | null;
}

class Live extends React.Component<IProp, IState> {
  private searchParams: { [s: string]: any } = getSearchParams();
  constructor(props: IProp) {
    super(props);
    this.state = {
      url: '',
      selectedIndex: 0,
      playBack: false,
      playBackLists: [],
      playbackInfo: {
        provider: -1,
        baijiayunPlaybacks: null,
        genseePlaybacks: null,
        easteduPlaybacks: null,
      },
      liveBroadcastInfo: {
        provider: -1,
        live: null,
        baijiayunRoom: null,
        genseeRoom: null,
      },
      liveType: null,
      liveTeacherInfo: null,
      liveUserInfo: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.liveDetails();
  }

  componentDidUpdate(prevProps: IProp) {
    const { reviews: preReviews } = prevProps;
    const { reviews } = this.props;
    if (preReviews !== reviews) {
      // 回看
      this.setState({
        playbackInfo: reviews,
        liveType: 'playback',
      });
    }
  }

  liveDetails = async () => {
    const { id, state, liveId } = this.searchParams;
    if (state === '2') {
      playBackAction.playBackInfo(id, liveId);
    } else {
      // liveAction.liveInfo(id, liveId);
      const { data } = await apiGetLive(liveId);
      // 获取当前直播状态，2表示直播已结束
      if (data.state === 2) {
        playBackAction.playBackInfo(id, liveId);
      } else {
        this.setState({
          liveType: 'live-broadcase',
        });
      }
    }
  };

  render() {
    const { playbackInfo, liveType } = this.state;
    const { liveId } = this.searchParams;

    return (
      <div className="live-view">
        <div className="live-content">
          {liveType === 'playback' && <LivePlayBack playbackInfo={playbackInfo} />}
          {liveType === 'live-broadcase' && (
            <EasteduLiveWeb
              liveId={liveId}
            />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  live: state.Live.live,
  lesson: state.Live.lesson,
  reviews: state.Live.reviews,
});
export default withRouter(connect(mapStateToProps, mergeProps)(Live));
